import { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import {
  Container,
  Table,
  Button,
  Form,
  Row,
  Col,
  Modal,
} from "react-bootstrap";

export const Pessoas = () => {
  const [people, setPeople] = useState([]);
  const [filteredPeople, setFilteredPeople] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalStatus, setShowModalStatus] = useState(false);
  const [editedOccurrence, setEditedOccurrence] = useState("");
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [occurrences, setOccurrences] = useState([]);
  const [nivel, setNivel] = useState("");

  const getPeople = async () => {
    try {
      const res = await blogFetch.get("/people");
      setPeople(res.data);
      setFilteredPeople(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getOccurrences = async () => {
    try {
      const res = await blogFetch.get("/occurrencePeople/all");
      setOccurrences(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getPeople();
    getOccurrences();
  }, []);

  const handleFilter = (value) => {
    setSearch(value);
    const term = value.toLowerCase();
    const filtered = people.filter(
      (p) =>
        p.peA_Name?.toLowerCase().includes(term) ||
        p.peA_cpf?.toLowerCase().includes(term)
    );
    setFilteredPeople(filtered);
  };

  const handleShowModal = (person) => {
    setSelectedPerson(person);
    const existing = occurrences.find(
      (o) => o.PEO_FK_peopleId === person.peA_PK_idPeople
    );
    setEditedOccurrence(existing?.PEO_description || "");
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditedOccurrence("");
    setSelectedPerson(null);
  };

  const handleOpenModalStatus = () => {
    setShowModal(false);
    setNivel(selectedPerson?.peA_statusOccurrence?.toString() || "");
    setShowModalStatus(true);
  };

  const handleCloseModalStatus = () => {
    setShowModalStatus(false);
    setSelectedPerson(null);
    setNivel("");
  };

  const handleSubmitOccurrence = async () => {
    try {
      const data = {
        PEO_description: editedOccurrence,
        PEO_FK_peopleId: selectedPerson.peA_PK_idPeople,
      };
      await blogFetch.post("/occurrencePeople", data);
      await getOccurrences();
      handleCloseModal();
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmitStatus = async () => {
    try {
      if (!nivel || !selectedPerson) return;
      await blogFetch.put(`/people/${selectedPerson.peA_PK_idPeople}`, {
        ...selectedPerson,
        peA_statusOccurrence: Number(nivel),
      });
      await getPeople();
      handleCloseModalStatus();
    } catch (error) {
      console.error(error);
    }
  };

  const colorOccurrence = (value) => {
    const colorMap = {
      1: "yellow",
      2: "orange",
      3: "red",
    };

    const color = colorMap[value];
    return color ? (
      <div
        style={{
          width: "15px",
          height: "15px",
          backgroundColor: color,
          margin: "auto",
        }}
      />
    ) : null;
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <Container fluid className="app_body py-4">
        <h3 className="fw-bold text-center mb-4">Pessoas</h3>

        <Form className="mb-4">
          <Row className="g-3">
            <Col md={4}>
              <Form.Control
                type="search"
                placeholder="Buscar nome ou documento"
                value={search}
                onChange={(e) => handleFilter(e.target.value)}
              />
            </Col>
          </Row>
        </Form>

        <div className="table-responsive" style={{ maxHeight: "600px" }}>
          <Table
            striped
            hover
            bordered
            size="lg"
            className="align-middle text-center"
            style={{ minWidth: "1000px" }}
          >
            <thead className="table-dark sticky-top" style={{ zIndex: 10 }}>
              <tr>
                {[
                  "Nome",
                  "Documento",
                  "Empresa",
                  "Telefone",
                  "Status",
                  "Ocorrência",
                  "Editar",
                ].map((col) => (
                  <th key={col} className="text-nowrap">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredPeople.length ? (
                filteredPeople.map((p, i) => {
                  const occ = occurrences.find(
                    (o) => o.access_People?.peA_PK_idPeople === p.peA_PK_idPeople
                  );
                  return (
                    <tr key={i}>
                      <td>{p.peA_Name || "-"}</td>
                      <td>{p.peA_cpf || "-"}</td>
                      <td>{p.peA_company || "-"}</td>
                      <td>{p.peA_phone || "-"}</td>
                      <td>{colorOccurrence(p.peA_statusOccurrence)}</td>
                      <td>{occ?.PEO_description || "-"}</td>
                      <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleShowModal(p)}
                        >
                          Editar
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7} className="text-muted fst-italic">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Editar Ocorrência</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Ocorrência</Form.Label>
              <Form.Control
                type="text"
                placeholder="Digite a ocorrência"
                value={editedOccurrence}
                onChange={(e) => setEditedOccurrence(e.target.value)}
              />
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleOpenModalStatus}
              >
                Alterar Status
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSubmitOccurrence}>
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showModalStatus} onHide={handleCloseModalStatus} centered>
          <Modal.Header closeButton>
            <Modal.Title>Alterar Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Select
              value={nivel}
              onChange={(e) => setNivel(e.target.value)}
            >
              <option value="">Selecione o status</option>
              <option value="3">Grave</option>
              <option value="2">Moderada</option>
              <option value="1">Leve</option>
            </Form.Select>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModalStatus}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSubmitStatus}>
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};
